import { render, staticRenderFns } from "./DialogConfirmDelete.pug?vue&type=template&id=5120bf81&scoped=true&lang=pug&"
import script from "./DialogConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmDelete.scss?vue&type=style&index=0&id=5120bf81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120bf81",
  null
  
)

export default component.exports